import { Alert, AlertProps } from 'antd';

function ModulesError(props: Readonly<Pick<AlertProps, 'message' | 'description'>>) {
  return (
    <div className="h-screen w-screen flex flex-col gap-4 items-center justify-start p-2">
      <Alert type="error" {...props} />
    </div>
  );
}

export { ModulesError };
